export default "__VITE_ASSET__C6roNa1A__"